module.exports = __webpack_public_path__ + "static/media/TRAN.e6389429.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/TRAN.jpg
// module id = 1782
// module chunks = 1